import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "@/context/AuthContext";
import { LocaleProvider } from "@/context/LocaleContext";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";

import { PublicLayout } from "@/components/layout/PublicLayout";
import HomePage from "@/pages/HomePage";
import SectionPage from "@/pages/SectionPage";
import DetailPage from "@/pages/DetailPage";
import SearchPage from "@/pages/SearchPage";
import NotFound from "@/pages/NotFound";
import LegalPage from "@/pages/legal/LegalPage";
import LoginPage from "@/pages/auth/LoginPage";
import RegisterPage from "@/pages/auth/RegisterPage";
import DashboardPage from "@/pages/dashboard/DashboardPage";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContentList from "@/pages/admin/AdminContentList";
import AdminContentEditor from "@/pages/admin/AdminContentEditor";
import AdminImport from "@/pages/admin/AdminImport";
import AdminTaxonomy from "@/pages/admin/AdminTaxonomy";
import AdminMerchants from "@/pages/admin/AdminMerchants";
import AdminMedia from "@/pages/admin/AdminMedia";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <LocaleProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/en" replace />} />

              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="content" element={<AdminContentList />} />
                <Route path="content/new" element={<AdminContentEditor />} />
                <Route path="content/:id/edit" element={<AdminContentEditor />} />
                <Route path="import" element={<AdminImport />} />
                <Route path="taxonomy" element={<AdminTaxonomy />} />
                <Route path="merchants" element={<AdminMerchants />} />
                <Route path="media" element={<AdminMedia />} />
              </Route>

              <Route path="/:locale" element={<PublicLayout />}>
                <Route index element={<HomePage />} />
                <Route path="search" element={<SearchPage />} />
                <Route path="login" element={<LoginPage />} />
                <Route path="register" element={<RegisterPage />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="privacy" element={<LegalPage doc="privacy" />} />
                <Route path="privacidad" element={<LegalPage doc="privacy" />} />
                <Route path="terms" element={<LegalPage doc="terms" />} />
                <Route path="terminos" element={<LegalPage doc="terms" />} />
                <Route path="voorwaarden" element={<LegalPage doc="terms" />} />
                <Route path="cookies" element={<LegalPage doc="cookies" />} />
                <Route path=":section" element={<SectionPage />} />
                <Route path="preview/:id" element={<DetailPage preview />} />
                <Route path=":section/:slug" element={<DetailPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route path="*" element={<Navigate to="/en" replace />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </LocaleProvider>
        </AuthProvider>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
